module.exports = __webpack_public_path__ + "img/stretch--genre5_tab-active.ab093d78.png";